export default "__VITE_ASSET__72b78e27__"